import React, { Component } from "react";
class ImageTag extends Component {
  render() {
    const { src, ...rest } = this.props;
    return <img src={src} {...rest} />;
  }
}

export default ImageTag;
